/**
 * Asynchronously loads the component for HomePage
 */

import React from 'react';
import loadable from '../../utils/loadable';
import LoadingIndicator from '../../components/LoadingIndicator';

export const BranchesListing = loadable(() => import('./Branches'), { fallback: <LoadingIndicator /> });

export const BranchDetails = loadable(() => import('./BranchDetails'), { fallback: <LoadingIndicator /> });
